import { usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/inertia"

// Room characteristics line + feature chips, shared by the public room cards
// (Rent a Room, Hebden Bridge). Renders nothing when the admin has not filled
// any details in.
export function RoomMeta({
  capacity,
  size_label,
  features,
}: {
  capacity: number | null
  size_label: string | null
  features: string[]
}) {
  const tc = usePage<PageProps>().props.translations.sanctuary_pages.common
  const meta = [
    capacity ? (tc.seats_up_to as string).replace("%{count}", String(capacity)) : null,
    size_label,
  ].filter(Boolean)

  if (meta.length === 0 && features.length === 0) return null

  return (
    <>
      {meta.length > 0 && <p className="mt-2 text-sm text-ink-muted">{meta.join(" · ")}</p>}
      {features.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {features.map((f) => (
            <span key={f} className="rounded-full bg-stone px-2.5 py-0.5 text-xs text-ink-body">
              {f}
            </span>
          ))}
        </div>
      )}
    </>
  )
}
